import {
    TemplateCard,
    type TemplateCardProps,
} from "@backstage/plugin-scaffolder-react/alpha";

const EXPERIMENTAL_LIFECYCLE = "experimental";
const EXPERIMENTAL_PREFIX = "🧪 EXPERIMENTAL\n\n";
const EXPERIMENTAL_TITLE_PREFIX = "🧪 ";

export function ExperimentalAwareTemplateCard(props: TemplateCardProps) {
    const { template, onSelected, ...rest } = props;
    const handleSelected = onSelected ? () => onSelected(template) : undefined;
    if (template.spec.lifecycle === EXPERIMENTAL_LIFECYCLE) {
        const { title, name, description } = template.metadata;
        const patched = {
            ...template,
            metadata: {
                ...template.metadata,
                title: EXPERIMENTAL_TITLE_PREFIX + (title ?? name),
                description: EXPERIMENTAL_PREFIX + (description ?? ""),
            },
        };
        return (
            <TemplateCard
                {...rest}
                template={patched}
                onSelected={handleSelected}
            />
        );
    }
    return (
        <TemplateCard
            {...rest}
            template={template}
            onSelected={handleSelected}
        />
    );
}
